export default function Footer() {
  return (
    <footer className="border-t border-white/10 py-14" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div className="flex items-center gap-5">
          <img src="/logo-mark.png" alt="Starscape Studio" className="h-9 w-auto" data-testid="footer-logo" />
          <div className="border-l border-white/15 pl-5">
            <p className="font-heading font-bold uppercase tracking-tight text-sm">Starscape Studio</p>
            <p className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-neutral-600 mt-1">
              Designing Spaces. Engineering Futures.
            </p>
          </div>
        </div>
        <p className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-neutral-600">
          © {new Date().getFullYear()} Starscape Studio — New Delhi
        </p>
      </div>
    </footer>
  );
}
